import React, { Component, Fragment } from "react";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import classnames from "classnames";
import _ from "i18n";

import {
  setCurrentNavPage,
  setAttachmentFileLink,
  initAccessKey,
  setCommentUpdate,
  AddComment,
  setCommentSlideCode,
  setTarget,
  addCommentContent,
  setDashboardSlides,
  setCompositionSlides,
  setPresentationTarget,
  setShowFrameExtraSlides,
  setDashboardListPageSize,
  setPresentationExtraSlides,
  setPresentationHiddenSlides,
  setPresentationCurrentSlideIndex,
  setPresentationExtraSlidesContent,
  initPresentation
} from "Actions";
import {
  fetchSlides,
  fetchDashboard,
  fetchPresentation,
  fetchPresentationUsers,
  savePresentation,
  fetchPresentationAccessKey,
  fetchComments,
  saveComment,
  saveVoiceComment,
  deleteComments,
  fetchAvailableDashboard,
  fetchIndicatorsExplanation
} from "Thunks";
import { Popconfirm } from "antd";
import { ModalConfirm } from "tamtam-components";
import { getTemporaryAnnexeFileLink, onSuccess, onError } from "Utils";
import { ICONS, SvgIcon } from "../Common/Icons";
import SimplePageHeader from "../Common/SimplePageHeader/SimplePageHeader";
import styles from "./PreparePresentation.local.scss";
import stylesButton from "../Common/Modal/Button.local.scss";
import SlidesPresentation from "./SlidesPresentation";
import PresentationConfig from "./PresentationConfig";
import ExtraSlidesConfig from "./ExtraSlidesConfig";
import AddExtraSlidesFrame from "./AddExtraSlidesFrame";
import GeneratedURLConfig from "./GeneratedURLConfig";
import SlideCommentsFrame from "./SlideCommentsFrame";
import browserHistory from "history/createBrowserHistory";
import NotFoundV2 from "../NotFound/NotFoundV2";
import SlidePosition from "./SlidePosition";
import SlidesList from "./SlidesList";
import { TTPReactModal } from "../Common/Modal/TTPReactModal";
import DashboardTemplatesFrame from "./DashboardTemplatesFrame";
import presentationApi from "../../services/presentationServices";

class PreparePresentationPage extends Component {
  organizationUen;

  constructor(props) {
    super(props);

    this.state = {
      slide: {
        selectedExtraSlide: null,
        page: null,
        slideContent: "",
        title: ""
      },
      isFrozen: props.isFrozen,
      defaultDashboard: {},
      year: null,
      addSwitchSlide: null,
      selectedSlide: null,
      hideIframe: true,
      loadingIframe: true,
      isNotFound: false,
      displayDashboardsModels: false,
      extraSlidesConfigIsVisible: true,
      addExtraSlide: false,
      isOpenModal: false,
      isOpenModalFreeze: false,
      isOpenModalDelete: false,
      frozenSlides: [],
      initialHiddenSlide: [],
      commentId: null
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    const indexString = window.location.href.split("/")[5];
    const index =
      indexString && indexString.includes("?")
        ? Number(indexString.split("?")[0] - 1)
        : Number(indexString - 1);

    let { uen } = this.props.match.params;

    this.organizationUen = uen;

    if (!this.organizationUen) {
      return false;
    }

    let year = this.getYearPresentation();
    this.setState({ year: year });
    dispatch(initPresentation());
    dispatch(fetchIndicatorsExplanation(this.organizationUen));
    dispatch(setCurrentNavPage("PREPARE_PRESENTATION_PAGE"));
    dispatch(setPresentationTarget(this.organizationUen));
    dispatch(
      fetchDashboard(year, this.organizationUen, this.organizationUen, null)
    );
    dispatch(fetchSlides());
    dispatch(fetchPresentation(this.organizationUen, year));
    dispatch(fetchPresentationUsers());
    dispatch(initAccessKey());
    dispatch(fetchPresentationAccessKey(this.organizationUen, year));
    dispatch(fetchComments(this.organizationUen, year));
    dispatch(setTarget(this.organizationUen));
    dispatch(setCommentSlideCode(index ? index + 1 : 1));
    dispatch(setPresentationCurrentSlideIndex(index ? index + 1 : 1));
    this.prepareInitialeDataState();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.isFrozen && this.props.isFrozen) {
      this.setState({ isFrozen: this.props.isFrozen });
    }
  }

  prepareInitialeDataState = () => {
    let { year, isFrozen } = this.state;
    const { token, lng, dashboardData, presentation } = this.props;

    let slides =
      dashboardData.slides && dashboardData.slides.length
        ? dashboardData.slides.filter(
            slide =>
              !["QUESTIONS_SLIDE", "EXTRA_SLIDE", "THANKING_SLIDE"].includes(
                slide.layout.type
              )
          )
        : [];
    let firstPreparation = Object.keys(presentation).length === 0;
    this.setState({
      isFrozen: firstPreparation ? true : isFrozen,
      frozenSlides: slides,
      initialHiddenSlide: firstPreparation ? [] : presentation.hiddenSlides
    });
    presentationApi
      .fetchDashboard(year, this.organizationUen, lng, token)
      .then(res => {
        this.setState({ defaultDashboard: res.data.data });
      })
      .catch(er => {
        this.setState({ defaultDashboard: {} });
      });
  };

  getYearPresentation = () => {
    let defaultYear = browserHistory().location.search;
    let year =
      defaultYear &&
      defaultYear.includes("year") &&
      defaultYear.replace("?year=", "").slice(0, 4);
    // : null;
    return year;
  };

  handleYearChange = value => {
    const { dispatch } = this.props;
    this.setState({ year: value });
    dispatch(push("?year=" + value));
  };

  handlerInputChange = event => {
    const { dispatch } = this.props;
    dispatch(addCommentContent(event.target.value));
  };

  handlerClearComment = () => {
    const { dispatch } = this.props;
    document.getElementById("new-comment").value = "";
    dispatch(addCommentContent(""));
  };

  handleDeleteComment = commentId => {
    this.setState({ commentId: commentId });
    this.setState({ isOpenModalDelete: true });
  };

  handlerUpdateComment = (slideCommentId, content) => {
    const { dispatch } = this.props;
    dispatch(addCommentContent(content));
    dispatch(setCommentUpdate(slideCommentId));
  };

  handleSaveVoiceComment = recording => {
    const { dispatch } = this.props;
    const { year } = this.state;
    let duree = document.getElementById("audio").duration;
    dispatch(saveVoiceComment(recording, year, duree)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: "comment Saved"
        });
        dispatch(fetchComments(this.organizationUen, year));
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
  };

  updateComment = slideCommentId => {
    const { dispatch, comments, comment } = this.props;
    const { period } = this.state;
    // let period = this.getYearPresentation();
    let newComment = [...comments];
    // eslint-disable-next-line array-callback-return
    newComment.map((slideComment, i) => {
      if (slideComment.id === slideCommentId) {
        newComment[i].content = comment.content;
      }
    });
    dispatch(saveComment(slideCommentId, period)).then(
      res => {
        onSuccess(res, {
          title: _("commentUpdated"),
          body: "comment updated"
        });
      },
      err => {
        onError(err.response.data.errors[0].message);
      }
    );
  };
  handleSaveComment = (slideCommentId = null) => {
    const { dispatch, comments, user, comment } = this.props;
    const { year } = this.state;
    // let period = this.getYearPresentation();
    if (comment.content !== "" && comment.content !== "\n") {
      let newComment = [];
      if (comments) {
        newComment = [...comments];
      }
      dispatch(saveComment(slideCommentId, year)).then(
        res => {
          onSuccess(res, {
            title: _("saveSuccess"),
            body: "comment Saved"
          });
          let response = res.value.data.data.slideComment;
          newComment.push({
            id: response.id,
            owner: response.owner,
            target: response.target,
            userId: response.userId,
            slideCode: response.slideCode,
            content: response.content,
            period: response.year,
            createdAt: response.createdAt,
            updatedAt: response.updatedAt,
            user: user.user
          });
          dispatch(AddComment(newComment));
          document.getElementById("new-comment").value = "";
        },
        err => {
          onError(err.response.data.errors[0].message);
        }
      );
    } else {
      onError(_("commentNull"));
    }
  };
  handlerkeyPressed = (event, commentId = null) => {
    if (event.key === "Enter") {
      if (commentId === null) {
        this.handleSaveComment(commentId);
      } else {
        if (document.getElementById(commentId).value.trim().length === 0) {
          onError(_("commentNull"));
        } else {
          this.updateComment(commentId);
        }
      }
    }
  };

  handleClosePage = () => {
    this.setState({ isOpenModal: true });
  };

  displayAnnexePDF = annexeCategory => {
    const { annexeAttachments, token } = this.props;
    this.setState({
      hideIframe: false,
      loadingIframe: true,
      isNotFound: false
    });

    let annexe = annexeAttachments.filter(
      ({ category }) => category.id === annexeCategory
    );

    if (annexe[0]) {
      this.props.dispatch(
        setAttachmentFileLink(
          getTemporaryAnnexeFileLink(annexe[0].id, annexe[0].filePath, token)
        )
      );
      setTimeout(() => {
        this.setState({ loadingIframe: false });
      }, 2000);
    } else {
      setTimeout(() => {
        this.setState({ loadingIframe: false, isNotFound: true });
      }, 2000);
    }
  };

  closeAnnexePDF = () => {
    this.setState({ hideIframe: true });
    this.props.dispatch(setAttachmentFileLink(""));
  };

  componentWillUnmount(): void {
    this.closeAnnexePDF();
  }

  handleAddSlide = () => {
    this.setState({
      ...this.state,
      addSwitchSlide: "ADD"
    });
  };

  handleSwitchSlide = slide => {
    this.setState({
      ...this.state,
      selectedSlide: slide,
      addSwitchSlide: "SWITCH"
    });
  };

  handleMoveSlide = slide => {
    this.setState({
      ...this.state,
      selectedSlide: slide,
      addSwitchSlide: "MOVE"
    });
  };

  handleCancleUpdateSlidesList = () => {
    this.setState({
      ...this.state,
      addSwitchSlide: null
    });
  };

  handleValidateUpdateSlidesList = slide => {
    const { dashboardData, dispatch, slides, currentSlideIndex } = this.props;
    let { addSwitchSlide, selectedSlide, year } = this.state;

    if (addSwitchSlide) {
      let filtredSlides = [...dashboardData.slides];
      let newSlides = { ...slides };
      if (addSwitchSlide === "SWITCH") {
        filtredSlides = dashboardData.slides.filter(
          slide => selectedSlide.code !== slide.code
        );
        let filtredSlide = dashboardData.slides.filter(
          slide => selectedSlide.code === slide.code
        )[0];
        newSlides[filtredSlide.status.toLowerCase()].push(filtredSlide);
        dispatch(setCompositionSlides(newSlides));
        filtredSlides.splice(currentSlideIndex, 0, slide);
        dispatch(setDashboardSlides(filtredSlides));
      }
      if (addSwitchSlide === "ADD") {
        filtredSlides.splice(currentSlideIndex + 1, 0, slide);
        this.reOrderExtraSlideIndex(currentSlideIndex + 1, null, true);
        dispatch(setDashboardSlides(filtredSlides));
        dispatch(setPresentationCurrentSlideIndex(currentSlideIndex + 1));
        let searchParams = browserHistory().location.search;
        window.history.pushState(
          "",
          "",
          `/prepare-presentation/${this.organizationUen}/${currentSlideIndex +
            1}` +
            (searchParams.includes("year") ? "" : `?year=${year}`) +
            searchParams
        );
      }
    }
    this.handleCancleUpdateSlidesList();
  };

  reOrderExtraSlideIndex = (index, oldPage, toPush) => {
    let {
      extraSlides: { slides },
      dispatch
    } = this.props;

    if (toPush === null) {
      slides.forEach(slide => {
        if (index > oldPage && slide.page <= index && slide.page > oldPage) {
          slide.page = slide.page - 1;
        } else if (
          index < oldPage &&
          slide.page >= index &&
          slide.page < oldPage
        ) {
          slide.page = slide.page + 1;
        }
      });
    } else {
      slides.forEach(slide => {
        if (slide.page > index) {
          slide.page = toPush ? slide.page + 1 : slide.page - 1;
        }
      });
    }
    dispatch(setPresentationExtraSlidesContent(slides));
  };

  handleValidateMoveSlidesList = (page, oldPage) => {
    const { dashboardData, dispatch } = this.props;
    let { selectedSlide, year } = this.state;
    let filtredSlides = dashboardData.slides.filter(
      slide => selectedSlide.code !== slide.code
    );
    let filtredSlide = dashboardData.slides.filter(
      slide => selectedSlide.code === slide.code
    )[0];
    filtredSlides.splice(page, 0, filtredSlide);
    this.reOrderExtraSlideIndex(page + 1, oldPage + 1, null);
    dispatch(setDashboardSlides(filtredSlides));
    dispatch(setPresentationCurrentSlideIndex(page));
    let searchParams = browserHistory().location.search;
    window.history.pushState(
      "",
      "",
      `/prepare-presentation/${this.organizationUen}/${page + 1}` +
        (searchParams.includes("year") ? "" : `?year=${year}`) +
        searchParams
    );
    this.handleCancleUpdateSlidesList();
  };

  handleHideSlide = code => {
    const {
      presentationConfig: { hiddenSlides },
      dispatch
    } = this.props;

    let hidden = [...hiddenSlides];
    if (hidden.includes(code)) {
      hidden = hiddenSlides.filter(id => id !== code);
    } else {
      hidden.push(code);
    }

    dispatch(setPresentationHiddenSlides(hidden));
  };

  handleDeleteSlide = deletedSlide => {
    const {
      currentSlideIndex,
      dashboardData,
      dispatch,
      slides,
      presentationConfig: { hiddenSlides }
    } = this.props;
    let newSlides = { ...slides };
    let filtredSlides = dashboardData.slides.filter(
      slide => slide.code !== deletedSlide.code
    );
    let newHiddenSlides = hiddenSlides.filter(
      code => code !== deletedSlide.code
    );
    newSlides[deletedSlide.status.toLowerCase()].push(deletedSlide);
    this.reOrderExtraSlideIndex(currentSlideIndex + 1, null, false);

    dispatch(setPresentationHiddenSlides(newHiddenSlides));
    dispatch(setCompositionSlides(newSlides));
    dispatch(setDashboardSlides(filtredSlides));
  };

  savePresentation = () => {
    const { dispatch, dashboardData, comments } = this.props;
    const { year, isFrozen } = this.state;
    let slides = dashboardData.slides.filter(
      slide =>
        !["QUESTIONS_SLIDE", "EXTRA_SLIDE", "THANKING_SLIDE"].includes(
          slide.layout.type
        )
    );
    let dashboard = { dashboard: { ...dashboardData, slides: slides } };
    let commentNonExisted = [];
    let slidesCode =
      slides && slides.length ? slides.map(({ code }) => code) : [];
    comments &&
      comments.lenght > 0 &&
      comments.map((item, i) => {
        if (!slidesCode.includes(item.slideCode)) {
          commentNonExisted.push(item.id);
        }
      });
    dispatch(
      savePresentation(this.organizationUen, year, dashboard, isFrozen ? 1 : 0)
    ).then(
      res => {
        commentNonExisted &&
          commentNonExisted.length &&
          dispatch(deleteComments(commentNonExisted));
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("savedConfiguration")
        });
        setTimeout(() => {
          year &&
            dispatch(
              push(`/fiche-client/${this.organizationUen}` + "/" + year)
            );
        }, 500);
      },
      err =>
        onError(
          err.response && err.response.data.errors
            ? err.response.data.errors[0].message
            : "errorOccured"
        )
    );
  };

  handleError = () => {
    const { error } = this.props;

    if (error.code === 170043) {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={"noBalanceImportedMessage"}
          buttonIgnored={1}
        />
      );
    } else if (error.code === 170060) {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={`${_("accessDenied")} : ${_("dashboardNotFound")}`}
          buttonIgnored={1}
        />
      );
    } else {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={"errorOccured"}
          buttonIgnored={1}
        />
      );
    }
  };

  handleSetCurrentSlide = slide => {
    this.setState({ slide: slide });
  };

  handleChangeFreezeState = () => {
    const { dispatch } = this.props;
    let { frozenSlides, initialHiddenSlide } = this.state;
    let state = !this.state.isFrozen;
    if (!state) {
      this.setState({ isOpenModalFreeze: true });
    } else {
      if (this.props.isFrozen && state) {
        dispatch(setPresentationHiddenSlides(initialHiddenSlide));
        dispatch(setDashboardSlides(frozenSlides));
      }
      this.setState({ isFrozen: true });
    }
  };

  handleAddExtraSlide = () => {
    this.props.dispatch(setShowFrameExtraSlides(true));
    this.setState({
      ...this.state,
      addExtraSlide: true
    });
  };
  //********************* DELETE EXTRA SLIDE *****************//
  handleDeleteExtraSlide = slideToDelete => {
    let {
      extraSlides: { slides },
      dispatch
    } = this.props;

    slides = slides.filter(slide => {
      return slide.key !== slideToDelete.key;
    });
    slides.forEach(slide => {
      if (slide.page > slideToDelete.page) {
        slide.page = slide.page - 1;
      }
    });

    dispatch(setPresentationExtraSlidesContent(slides));
  };

  handleDisplayDashboardTemplates = () => {
    this.setState({ loadingDashboards: true });
    this.props.dispatch(setDashboardListPageSize(6));
    this.props.dispatch(fetchAvailableDashboard());
    this.setState({
      ...this.state,
      displayDashboardsModels: true
    });
  };

  handleEditExtraSlide = slide => {
    this.props.dispatch(setShowFrameExtraSlides(true));
    this.setState({
      ...this.state,
      slide: {
        selectedExtraSlide: slide,
        page: slide.page,
        slideContent: slide.content,
        title: slide.title
      },
      addExtraSlide: false
    });
  };

  renderDashboardTemplatesAction = () => {
    return (
      <div className={styles.presentation_action}>
        <button
          type="button"
          onClick={() => this.handleDisplayDashboardTemplates()}
        >
          <SvgIcon icon={ICONS.REPEAT_ICON} />
          {_("applyDashboardTemplate")}
        </button>
      </div>
    );
  };

  renderSlideActionsContainer = () => {
    const {
      dashboardData,
      currentSlideIndex,
      presentationConfig: { hiddenSlides }
    } = this.props;
    let { addSwitchSlide, isFrozen } = this.state;
    let currentSlide = dashboardData.slides[currentSlideIndex];
    return (
      <div className={styles.slides_actions_container}>
        {currentSlide &&
          !["QUESTIONS_SLIDE", "THANKING_SLIDE"].includes(
            currentSlide.layout.type
          ) && (
            <Fragment>
              <div className={styles.slides_action_upper}>
                {currentSlide.layout.type === "EXTRA_SLIDE" ? (
                  <button
                    type="button"
                    className={styles.slides_action_button}
                    onClick={() =>
                      this.handleEditExtraSlide({
                        ...currentSlide.layout.components[0]
                      })
                    }
                  >
                    <SvgIcon icon={ICONS.PENCIL} />
                  </button>
                ) : isFrozen ? (
                  <Fragment>
                    <div className={styles.set_action}>
                      <button
                        type="button"
                        className={styles.slides_action_button}
                        onClick={() => this.handleMoveSlide(currentSlide)}
                      >
                        <SvgIcon icon={ICONS.MOVE_SLIDE} />
                      </button>
                      {addSwitchSlide === "MOVE" && (
                        <SvgIcon
                          icon={ICONS.DoubleArrowUp}
                          className={styles.arrow_open}
                        />
                      )}
                    </div>
                    <div className={styles.set_action}>
                      <button
                        type="button"
                        className={styles.slides_action_button}
                        onClick={() => this.handleSwitchSlide(currentSlide)}
                      >
                        <SvgIcon icon={ICONS.SWITCH_SLIDE} />
                      </button>
                      {addSwitchSlide === "SWITCH" && (
                        <SvgIcon
                          icon={ICONS.DoubleArrowUp}
                          className={styles.arrow_open}
                        />
                      )}
                    </div>
                  </Fragment>
                ) : (
                  <div />
                )}
                {currentSlide &&
                  currentSlide.id !== 0 && (
                    <button
                      type="button"
                      className={styles.slides_action_button}
                      onClick={() => this.handleHideSlide(currentSlide.code)}
                    >
                      <SvgIcon
                        icon={
                          hiddenSlides.find(
                            index => index === currentSlide.code
                          )
                            ? ICONS.CLOSED_EYE
                            : ICONS.OPEN_EYE
                        }
                      />
                    </button>
                  )}
                {currentSlide && currentSlide.id !== 0 ? (
                  isFrozen ? (
                    <button
                      type="button"
                      className={classnames(
                        styles.slides_action_button,
                        styles.slide_remove
                      )}
                      onClick={() => this.handleDeleteSlide(currentSlide)}
                    >
                      <SvgIcon icon={ICONS.DELETE_ICON} />
                    </button>
                  ) : (
                    <div />
                  )
                ) : (
                  <Popconfirm
                    title={_("deleteConfirmation")}
                    okText={_("yes")}
                    cancelText={_("cancel")}
                    onConfirm={event => {
                      event.stopPropagation();
                      this.handleDeleteExtraSlide({
                        ...currentSlide.layout.components[0]
                      });
                    }}
                    onCancel={event => {
                      event.stopPropagation();
                    }}
                  >
                    <button
                      type="button"
                      className={classnames(
                        styles.slides_action_button,
                        styles.slide_remove
                      )}
                      onClick={event => {
                        event.stopPropagation();
                      }}
                    >
                      <SvgIcon icon={ICONS.DELETE_ICON} />
                    </button>
                  </Popconfirm>
                )}
              </div>
              <hr />
              {isFrozen ? (
                <div
                  className={classnames(
                    styles.set_action,
                    styles.slide_set_add
                  )}
                >
                  <button
                    type="button"
                    className={classnames(
                      styles.slides_action_button,
                      styles.slide_add
                    )}
                    onClick={() => this.handleAddSlide(currentSlideIndex)}
                  >
                    <SvgIcon icon={ICONS.SIMPLE_PLUS_ICON} />
                  </button>
                  {addSwitchSlide === "ADD" && (
                    <SvgIcon
                      icon={ICONS.DoubleArrowUp}
                      className={styles.arrow_open}
                    />
                  )}
                </div>
              ) : (
                <div />
              )}
            </Fragment>
          )}
      </div>
    );
  };

  handlePageChange = index => {
    const { dashboardData } = this.props;
    let { addSwitchSlide } = this.state;
    dashboardData &&
      dashboardData.slides &&
      dashboardData.slides.forEach((slide, i) => {
        if (
          ["EXTRA_SLIDE", "QUESTIONS_SLIDE", "THANKING_SLIDE"].includes(
            slide.layout.type
          ) &&
          index === i &&
          addSwitchSlide === "SWITCH"
        ) {
          this.setState({
            ...this.state,
            addSwitchSlide: null
          });
        }
      });
  };

  renderRightSideByAction = () => {
    let { selectedSlide, addSwitchSlide } = this.state;
    const {
      lng,
      slides,
      composition,
      dashboardData,
      currentSlideIndex
    } = this.props;

    let slidesCodes = [];
    dashboardData &&
      dashboardData.slides &&
      dashboardData.slides.forEach(slide => {
        if (
          !["EXTRA_SLIDE", "QUESTIONS_SLIDE", "THANKING_SLIDE"].includes(
            slide.layout.type
          )
        ) {
          slidesCodes.push(slide.code);
        }
      });
    let filtredSlides = {
      standard:
        Object.keys(slides).length > 0 && slides.standard
          ? slides.standard.filter(slide => !slidesCodes.includes(slide.code))
          : [],
      created:
        Object.keys(slides).length > 0 && slides.created
          ? slides.created.filter(slide => !slidesCodes.includes(slide.code))
          : [],
      used:
        Object.keys(slides).length > 0 && slides.used
          ? slides.used.filter(slide => !slidesCodes.includes(slide.code))
          : []
    };
    let title =
      addSwitchSlide === "ADD" ? "addSlideTemplate" : "switchSlideTemplate";

    switch (addSwitchSlide) {
      case "ADD":
      case "SWITCH":
        return (
          <SlidesList
            lng={lng}
            title={title}
            slides={filtredSlides}
            data={dashboardData}
            composition={composition}
            currentIndex={currentSlideIndex}
            validateAction={this.handleValidateUpdateSlidesList}
            cancelAddSlide={this.handleCancleUpdateSlidesList}
          />
        );
      case "MOVE":
        return (
          <SlidePosition
            lng={lng}
            data={dashboardData}
            slide={selectedSlide}
            currentIndex={currentSlideIndex}
            validateAction={this.handleValidateMoveSlidesList}
            cancelMoveSlide={this.handleCancleUpdateSlidesList}
          />
        );

      default:
        return <div />;
    }
  };

  render() {
    const {
      fetching,
      fetched,
      error,
      saving,
      comments,
      dispatch,
      extraSlides,
      organization,
      dashboardData,
      currentSlideIndex,
      attachmentFileLink,
      currentOrganization,
      withoutHeader
    } = this.props;
    let {
      slide,
      year,
      isFrozen,
      commentId,
      hideIframe,
      isNotFound,
      isOpenModal,
      loadingIframe,
      addExtraSlide,
      addSwitchSlide,
      defaultDashboard,
      isOpenModalDelete,
      isOpenModalFreeze,
      displayDashboardsModels
    } = this.state;

    let commentIds =
      comments && comments.length ? comments.map(({ id }) => id) : [];

    return (
      <div>
        <SimplePageHeader
          closePage={this.handleClosePage}
          title={_("presentationPreparation")}
          handleYearChange={this.handleYearChange}
          primaryButton={{
            label: _("saveFinish"),
            action: this.savePresentation,
            saving: saving,
            isDisabled: false
          }}
        />
        <ModalConfirm
          type={"return"}
          isOpen={isOpenModal}
          onCancel={() => this.setState({ isOpenModal: false })}
          onConfirm={() => {
            let period = year;
            period &&
              dispatch(push(`/fiche-client/${this.organizationUen}/${period}`));
          }}
          inProcess={false}
          actionFailed={false}
          title={_("exitConfirm")}
          text={_("cancelConfirmContent")}
          labelNo={_("cancel")}
          labelYes={_("exit")}
          labelError={"Error"}
        />
        {fetching && (
          <div className={styles.ripple_loading_adapted}>
            <img src={"/img/Ripple-1s-150px.svg"} alt="" />
          </div>
        )}
        {error && !fetching && this.handleError()}
        {!error &&
          fetched && (
            <div>
              <div
                className={classnames(
                  styles.left_side,
                  withoutHeader ? styles.without_header : ""
                )}
              >
                {/*  Presentation slides */}
                {extraSlides.showFrame ? (
                  <AddExtraSlidesFrame
                    slide={slide}
                    addExtraSlide={addExtraSlide}
                    year={year}
                  />
                ) : displayDashboardsModels ? (
                  <DashboardTemplatesFrame
                    onCancel={() =>
                      this.setState({ displayDashboardsModels: false })
                    }
                    uen={this.organizationUen}
                    commentsIds={commentIds}
                    dispatch={dispatch}
                    year={year}
                  />
                ) : (
                  <Fragment>
                    {isFrozen ? this.renderDashboardTemplatesAction() : ""}
                    <SlidesPresentation
                      data={dashboardData}
                      organization={organization}
                      dispatch={dispatch}
                      handleDisplayAnnexePDF={this.displayAnnexePDF}
                      hideIframe={hideIframe}
                      srcIframe={attachmentFileLink}
                      loadingIframe={loadingIframe}
                      onCloseIframe={this.closeAnnexePDF}
                      isNotFound={isNotFound}
                      currentOrganization={currentOrganization}
                      onPageChange={this.handlePageChange}
                      year={year}
                    />
                    {this.renderSlideActionsContainer()}
                    <div className={styles.lower_section}>
                      <SlideCommentsFrame
                        data={dashboardData}
                        slideIndex={currentSlideIndex}
                        handleInputChange={this.handlerInputChange}
                        keyPressed={this.handlerkeyPressed}
                        saveComment={this.handleSaveComment}
                        clearComment={this.handlerClearComment}
                        deleteComment={this.handleDeleteComment}
                        updateComment={this.handlerUpdateComment}
                        saveVoiceComment={this.handleSaveVoiceComment}
                      />
                      <ModalConfirm
                        type={"delete"}
                        isOpen={isOpenModalDelete}
                        onCancel={() =>
                          this.setState({ isOpenModalDelete: false })
                        }
                        onConfirm={() => {
                          let updatedComments = [...comments];
                          return new Promise((resolve, reject) => {
                            dispatch(deleteComments([commentId])).then(
                              res => {
                                onSuccess(res, {
                                  title: _("removeSuccess"),
                                  body: _("commentDeleted")
                                });
                                resolve(true);
                                dispatch(
                                  AddComment(
                                    updatedComments.filter(
                                      ({ id }) => id !== commentId
                                    )
                                  )
                                );
                                this.setState({ isOpenModalDelete: false });
                              },
                              err => {
                                onError(err.response.data.errors[0].message);
                                reject(true);
                              }
                            );
                          }).catch(() => console.log("Oops errors!"));
                        }}
                        inProcess={false}
                        actionFailed={false}
                        title={_("deleteConfirmation")}
                        text={_("deleteCommentContent")}
                        labelNo={_("cancel")}
                        labelYes={_("Delete")}
                        labelError={"Error"}
                      />
                      <TTPReactModal
                        title={_("chooseExtraSLide")}
                        isOpen={isOpenModalFreeze}
                        onCancel={() =>
                          this.setState({ isOpenModalFreeze: false })
                        }
                        width={800}
                        footer={[
                          <button
                            key="back"
                            className={stylesButton.back}
                            onClick={() =>
                              this.setState({ isOpenModalFreeze: false })
                            }
                          >
                            {_("cancel")}
                          </button>,
                          <button
                            key="submit"
                            type="default"
                            className={stylesButton.save}
                            onClick={() => {
                              return new Promise((resolve, reject) => {
                                dispatch(setPresentationExtraSlides(0));
                                dispatch(setPresentationHiddenSlides([]));
                                dispatch(
                                  setDashboardSlides(defaultDashboard.slides)
                                );
                                this.setState({
                                  isOpenModalFreeze: false,
                                  isFrozen: false
                                });
                              }).catch(() => console.log("Oops errors!"));
                            }}
                          >
                            {this.state.loading && (
                              <img
                                src={"/img/icons/tail-spin.svg"}
                                alt={""}
                                className={stylesButton.loading}
                              />
                            )}
                            {_("apply")}
                          </button>
                        ]}
                      >
                        <div className={styles.modal_sum_up}>
                          <div className={styles.modal_sum_up_details}>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: _(
                                  "confirmationUnFreezePresentationMessage"
                                )
                              }}
                            />
                          </div>
                        </div>
                      </TTPReactModal>
                    </div>
                  </Fragment>
                )}
              </div>
              <div className={styles.right_side}>
                {addSwitchSlide ? (
                  this.renderRightSideByAction()
                ) : (
                  <Fragment>
                    <PresentationConfig
                      isFrozen={this.state.isFrozen}
                      onChangeIsFreezed={this.handleChangeFreezeState}
                    />
                    <ExtraSlidesConfig
                      handleSetCurrentSlide={this.handleSetCurrentSlide}
                      handleAddExtraSlide={this.handleAddExtraSlide}
                      handleEditExtraSlide={this.handleEditExtraSlide}
                      handleDeleteExtraSlide={this.handleDeleteExtraSlide}
                      selectedSlide={slide.selectedExtraSlide}
                      addExtraSlide={addExtraSlide}
                      year={year}
                    />
                    <GeneratedURLConfig />
                  </Fragment>
                )}
              </div>
            </div>
          )}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching:
    state.dashboard.fetching ||
    state.presentation.fetching ||
    state.presentation.users.fetching ||
    state.accessKey.fetching ||
    state.preparePresentation.fetching,
  fetched:
    state.dashboard.fetched &&
    state.presentation.fetched &&
    state.presentation.users.fetched &&
    state.accessKey.fetched &&
    state.preparePresentation.fetched,
  saving: state.presentation.saving,
  presentation: state.presentation.data,
  slides: state.dashboardComposition.slides,
  slideId: state.preparePresentation.comment.slideId,
  dashboardData: state.dashboard.data,
  organization: state.dashboard.organization,
  attachmentFileLink: state.dashboard.attachmentFileLink,
  currentOrganization: state.auth.currentOrganization,
  annexeAttachments: state.dashboard.data.annexeAttachments,
  token: state.auth.token,
  isFrozen: state.presentation.presentationConfig.isFrozen,
  presentationConfig: state.presentation.presentationConfig,
  currentSlideIndex: state.presentation.currentSlideIndex,
  comments: state.preparePresentation.items.comments,
  slideList: state.slideList.items,
  comment: state.preparePresentation.comment,
  owner: state.auth.currentOrganization.uen,
  user: state.auth,
  lng: state.params.lng,
  extraSlides: state.presentation.presentationConfig.extraSlides,
  composition: state.dashboardComposition.composition,
  extraInfos: state.dashboard.data.extraInfos,
  error: state.dashboard.error,
  withoutHeader: state.auth.withoutHeader
});

export default connect(mapStateToProps)(PreparePresentationPage);



// WEBPACK FOOTER //
// ./src/components/PreparePresentation/PreparePresentationPage.js